import * as types from '../types';
const checkExerciseRequested = id => ({
  id,
  type: types.CHECK_EXERCISE_REQUESTED
});
export default checkExerciseRequested;